import { EConditionType } from '../../../../json_query';
import { changeManufactureCondition } from '../../../state/advanced/manufacture_condition';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const ManufactureCondition = getMultiSelectParam<EConditionType>(
  'Состояние',
  [
    { title: 'Типовой ремонт', value: EConditionType.RegularRepair },
    { title: 'Требуется капитальный ремонт', value: EConditionType.MajorRepairNeeded },
    { title: 'Требуется коcметический ремонт', value: EConditionType.CosmeticRepairNeeded },
  ],
  'condition_type__industry',
  changeManufactureCondition,
);
